export default __webpack_public_path__ + "static/media/bk.9be50835.jpg";